// Vendor imports
const PropTypes = require('prop-types')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('OpenInAppButton')

class OpenInAppButton extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      isDismissed: false,
      isVisible: props.isVisible
    }

    this.onDismiss = this.onDismiss.bind(this)
    this.onOpen = this.onOpen.bind(this)
  }

  // State methods

  hide() {
    this.setState(() => ({ isDismissed: true }))
  }

  // Event methods

  onDismiss(event) {
    event.stopPropagation()
    this.hide()
    this.props.onDismiss()
  }

  onOpen() {
    this.hide()
    this.props.onOpen()
  }

  // Render methods

  render() {
    if (!this.state.isVisible) {
      return null
    }
    return tag('div', {
      className: bem.block({
        dismissed: this.state.isDismissed
      }),
      onClick: this.onOpen
    },
      'Open in App',
      tag('button', {
        className: bem.element('close'),
        type: 'button',
        onClick: this.onDismiss
      })
    )
  }
}

OpenInAppButton.propTypes = {
  // Flags
  isVisible: PropTypes.bool,
  // Callbacks
  onDismiss: PropTypes.func,
  onOpen: PropTypes.func
}

module.exports = OpenInAppButton
